module.exports = new __parcel__URL__("Engineerskill_07.40ee855e.png").toString();